var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 30,
    r: 22,
    stroke: "#E82626",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3369 20.291L24.4901 34.9327C24.4918 34.9441 24.5082 34.9441 24.5099 34.9327L26.6631 20.291C26.8407 19.0836 25.9048 18 24.6844 18H24.3156C23.0952 18 22.1593 19.0836 22.3369 20.291Z",
    fill: "#E82626",
    stroke: "#E82626",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 41.063C26.5 42.1676 25.6046 43.063 24.5 43.063C23.3954 43.063 22.5 42.1676 22.5 41.063C22.5 39.9584 23.3954 39.063 24.5 39.063C25.6046 39.063 26.5 39.9584 26.5 41.063Z",
    fill: "#E82626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.d370432d07db9bb60aa7a99f92132405.svg";
export { ForwardRef as ReactComponent };